// Widgets rendered in a WebView by the player. Old Android System WebViews
// (Android <= 9 devices) can't play them and show a black screen.
export const WEBVIEW_WIDGETS = {
  vimeo: 'Vimeo',
  embed: 'Embed',
  twitch: 'Twitch',
};

export const WEBVIEW_MAX_UNSUPPORTED_ANDROID = 9;

// Unknown OS version (not reported yet) is treated as supported.
export const isLegacyAndroid = (osVersion) => {
  const major = parseInt(osVersion, 10);
  return (
    Number.isFinite(major) &&
    major > 0 &&
    major <= WEBVIEW_MAX_UNSUPPORTED_ANDROID
  );
};

const collectFromContent = (content, found) => {
  if (!content) return;

  if (content.type === 'split_screen') {
    (content.widget?.zones || []).forEach((zone) => {
      const obj = zone?.object;
      if (!obj) return;
      if (Array.isArray(obj.content)) {
        obj.content.forEach((item) => collectFromContent(item?.content, found));
      } else {
        collectFromContent(obj, found);
      }
    });
    return;
  }

  const cat = content.widget?.widgetCat;
  if (WEBVIEW_WIDGETS[cat]) {
    found.push({
      id: content._id,
      name: content.name || WEBVIEW_WIDGETS[cat],
      widgetCat: cat,
      label: WEBVIEW_WIDGETS[cat],
    });
  }
};

// Accepts a single content object, or a playlist ({ content: [{ content }] }).
export const getWebviewContentIssues = (target) => {
  const found = [];
  if (!target) return found;

  if (Array.isArray(target.content)) {
    target.content.forEach((item) => collectFromContent(item?.content, found));
  } else {
    collectFromContent(target, found);
  }

  const seen = new Set();
  return found.filter((issue) => {
    const key = `${issue.id}|${issue.name}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

// Issues for content assigned to a screen; empty when the device is supported.
export const getScreenWebviewIssues = (screen) =>
  isLegacyAndroid(screen?.device_details?.os_version)
    ? getWebviewContentIssues(screen?.playlist)
    : [];
